import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import vuetify from './plugins/vuetify';
import router from './router'
import store from './store'
import * as VueGoogleMaps from 'vue2-google-maps'
import '@fortawesome/fontawesome-free/css/all.css'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

Vue.use(require('vue-moment'));
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCB4oc_Xp20fcYxZvzWfQHmfVUKPLfr6-Q',
    libraries: 'places',
    region: 'JP',
    language: 'ja'
  }
})

Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.use(VueAxios, axios) //追記
Vue.use(VueSweetalert2);
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
